// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__aEe1K","custom_link":"_styles_custom_link__7Y2+w"};